export type Solicitacao = {
  id: number;
  cnpj: string;
  nomeEmpresaOrgao: string;
  dataSolicitacao: string;
  setorUsuario: string;
  situacao: Situacao;
  siglaEmpresaOrgao: string;
  uf: string;
  municipio: string;
  emailGestor: string;
  telefoneContato: string;
  emailContato: string;

  motivoRecusa?: string;
};

export enum Situacao {
  Pendente = 'Pendente',
  Reprovado = 'Reprovado',
  EmAnalise = 'Em análise',
  Aprovado = 'Aprovado',
}
